export default __webpack_public_path__ + "static/media/Hideous.f8985ddd.ttf";